var Marionette = require('backbone.marionette');
var DocumentSignStatisticView = require('./document-sign-statistic-view');
var DocumentSignStatisticByCommentsView = require('./document-sign-statistic-by-comments-view');
var DocumentSignStatisticByComments2View = require('./document-sign-statistic-by-comments-view-2');

var StatisticsView = Marionette.View.extend({
    template: require('../../templates/statistics/statistics-main-view.html'),

    regions: {
        mdsSignedRegion: '#mds-signed-content',
        mdsPendingRegion: '#mds-pending-content',
        orgsSignedRegion: '#orgs-signed-content',
        orgsPendingRegion: '#orgs-pending-content',
        documentStatisticsByCommentsRegion: '#by-comments-content',
        documentStatisticsByComments2Region: '#by-comments-content-2'
    },

    initialize: function (options) {
        _.bindAll(this, 'onRender', 'renderMdsSignedTab', 'renderMdsPendingTab', 'renderOrgsSignedTab', 'renderOrgsPendingTab');

        this.initFlags = {
            mdsSignedTabIsInit: false,
            mdsPendingTabIsInit: false,
            orgsSignedTabIsInit: false,
            orgsPendingTabIsInit: false,
            documentStatisticByCommentsTabsInit: false,
            documentStatisticByComments2TabsInit: false
        };
    },

    onRender: function () {
        window.document.title = "Statistics";
        var that = this;

        that.renderMdsSignedTab();

        that.$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            var target = that.$(e.target).attr("href");

            if (target == '#mds-signed') {
                that.renderMdsSignedTab();
            } else if (target == '#mds-pending') {
                that.renderMdsPendingTab();
            } else if (target == '#orgs-signed') {
                that.renderOrgsSignedTab();
            } else if (target == '#orgs-pending') {
                that.renderOrgsPendingTab();
            } else if (target == '#by-comments') {
                that.renderDocumentStatisticsByComments();
            } else if (target == '#by-comments-2') {
                that.renderDocumentStatisticsByComments2();
            }
        });
    },

    renderMdsSignedTab: function () {
        var that = this;
        if (this.initFlags.mdsSignedTabIsInit)
            return;

        that.showChildView('mdsSignedRegion', new DocumentSignStatisticView({
            forSigned: true,
            forMd: true
        }));
        this.initFlags.mdsSignedTabIsInit = true;
    },

    renderMdsPendingTab: function () {
        var that = this;
        if (this.initFlags.mdsPendingTabIsInit)
            return;

        that.showChildView('mdsPendingRegion', new DocumentSignStatisticView({
            forSigned: false,
            forMd: true
        }));
        this.initFlags.mdsPendingTabIsInit = true;
    },

    renderOrgsSignedTab: function () {
        var that = this;
        if (this.initFlags.orgsSignedTabIsInit)
            return;

        that.showChildView('orgsSignedRegion', new DocumentSignStatisticView({
            forSigned: true,
            forMd: false
        }));
        this.initFlags.orgsSignedTabIsInit = true;
    },

    renderOrgsPendingTab: function () {
        var that = this;
        if (this.initFlags.orgsPendingTabIsInit)
            return;

        that.showChildView('orgsPendingRegion', new DocumentSignStatisticView({
            forSigned: false,
            forMd: false
        }));
        this.initFlags.orgsPendingTabIsInit = true;
    },

    renderDocumentStatisticsByComments: function () {
        var that = this;
        if (this.initFlags.documentStatisticByCommentsTabsInit)
            return;

        this.showChildView('documentStatisticsByCommentsRegion', new DocumentSignStatisticByCommentsView());
        this.initFlags.documentStatisticByCommentsTabsInit = true;
    },

    renderDocumentStatisticsByComments2: function () {
        var that = this;
        if (this.initFlags.documentStatisticByComments2TabsInit)
            return;

        this.showChildView('documentStatisticsByComments2Region', new DocumentSignStatisticByComments2View());
        this.initFlags.documentStatisticByComments2TabsInit = true;
    }

});


module.exports = StatisticsView;


//////////////////
// WEBPACK FOOTER
// ./app/views/statistics/statistics-main-view.js
// module id = 463
// module chunks = 0